<template>
  <div>
    <v-container
      fluid
      class="pa-0 info-drawer"
    >
      <div class="pa-6 pl-8 pb-4">
        <h2 class="d-flex justify-space-between align center">
          {{ mode === 'update' ? 'Edit API Key' : 'Add API Key' }}
          <v-btn
            icon
            @click.stop="$store.commit('ui/drawer.right.toggle')"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </h2>
      </div>

          <v-form
            v-model="isValid"
            ref="keyName"
            lazy-validation
            @submit.enter.prevent
          >
            <v-text-field
              v-model.trim="apiKeyName"
              :rules="keyNameRules"
              outlined
              class="pa-0 pb-0 text--grey pl-8 pr-6"
              label="Key Name"
              hint="32 characters maximum"
            />
          </v-form>
          <div class="pa-0 pl-8 pr-6">
            <v-list class="ip-section my-5 pb-2">
              <v-list-item class="pa-0 ml-n1 mt-n10">
                  <v-list-item-content class="pa-0">
                      <v-list-item-title class="body-2">
                        <span class="ip-address-title">Whitelisted IP Addresses ({{whitelistedIps.length}}/{{ this.ipAddressLimit }})
                          <v-tooltip
                            top
                            color="rgba(0, 0, 0, 0.9)"
                            max-width="480"
                          >
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on">mdi-information-outline</v-icon>
                            </template>
                            <span>
                              Enter IPv4 addresses from which API requests will only be accepted.
                              Leave blank to allow requests from all IP addresses.
                            </span>
                        </v-tooltip>
                        </span>
                      </v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
              <v-list-item class="pa-0 pr-4">
                <v-text-field
                  ref="ipAddress"
                  v-model="ipAddress"
                  outlined
                  dense
                  class="text--grey more-detail"
                  label=""
                  placeholder="IPv4 Address"
                  :rules="ipAddressRules"
                />
                <v-btn
                  :disabled="invalidIp"
                  :dark="!invalidIp"
                  v-track="`add-ipv4-address`"
                  dense
                  class="mt-n5 ml-2"
                  @click="onAddIpAddress"
                >
                  Add
                </v-btn>
              </v-list-item>
              <div class="ip-list">
                <v-list-item
                  v-for="(ip, index) in whitelistedIps"
                  :key="index"
                  class="pa-0 pr-4"
                >
                  <v-list-item-content>
                      <v-list-item-title>{{ ip }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      icon
                      v-track="`remove-privileges-changes`"
                      @click="onRemoveIpAddress(index)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </v-list>
            <v-list class="ma-0 pa-0">
              <v-list-item class="pa-0 pr-4 mt-n3" key="all-privileges">
                  <v-list-item-content class="pa-0">
                      <v-list-item-title class="body-2">API PRIVILEGES</v-list-item-title>
                  </v-list-item-content>
              </v-list-item>
              <v-divider v-if="!loading"></v-divider>
              <div v-if="loading" class="text-center">
                <v-progress-linear
                  indeterminate
                  color="grey"
                  height="2"
                ></v-progress-linear>
              </div>
              <div v-if="!loading">
              <v-list-item class="pa-0 pr-4" key="test">
                  <v-list-item-content>
                      <v-list-item-title>Select All</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                        <v-switch v-track="'select-all-permission-toggle'" :color="blueIcon" v-model="isSelectAll" @change="selectAllPermissions"></v-switch>
                    </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>

              <v-list-item-group multiple>
              <template v-for="(item, index) in apiKeyItems">
                <v-list-item class="pa-0 pr-4" @click.stop="" :key="item.title">
                    <template v-slot:default="{ active }">
                    <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-switch v-track="`${index}-toggle`" color="mpBlue" @change="manageSelection" v-model="item.hasPermission"></v-switch>
                    </v-list-item-action>
                    </template>
                </v-list-item>

                <v-divider
                    :key="index"
                ></v-divider>
              </template>
              </v-list-item-group>
              </div>
          </v-list>

            <v-row>
              <v-col cols='12'>
                <v-btn
                  v-if="!loading"             
                  @click.stop="saveKeyInfo()"
                  v-track="`save-privileges-changes`"
                  id="save-create-user-drawer-btn"
                  :disabled="isBtnDisabled"
                  :dark="!isBtnDisabled"
                  :loading="submissionLoading"
                >
                  SAVE
                </v-btn>
              </v-col>
            </v-row>
          </div>
    </v-container>
  </div>
</template>
  <script>
  import { $settings } from '@/services'
  import constants from '@/constants'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        allSelected: false,
        currentPage: 1,
        loading: false,
        apiKeyName: '',
        isValid: true,
        isSelectAll: true,
        mode: 'create',
        permissionOptions: [],
        apiKeyItems: {},
        permissionInfo: {campaigns: 'Campaigns', account: 'Account and Users', contacts: 'Contacts', download_contacts: 'Download Contacts', contents: 'Contents', surveys: 'Surveys', reports: 'Create Reports', download_reports: 'Download Reports', automation: 'Automations', forms: 'Forms', relational_tables: 'Relational Tables', ftp: 'FTP', mobile: 'Mobile', push_notifications: 'Push Notifications', coupon_codes: 'Coupon Codes'},
        keyNameRules: [
          v => !!v || 'Key name is required',
          v => !v || (/^[^\s]/).test(v) || "Key name cannot start with a space",
          v =>
          /^(?:(?!(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff]))[^]){1,255}$/.test(
            v
          ) || 'You cannot use emojis in this field.',
          v => (v && v.length <= 32) || "You've exceeded the maximum character count",
        ],
        ipAddressLimit: 50,
        ipAddressRules: [
          v => !v || (/^(?!0)(?!.*\.\0)(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])$/).test(v) || 'IP address must be in IPv4 format',
          v => !v || !this.whitelistedIps.includes(v) || 'IP Address already added',
          v => !v || this.whitelistedIps.length < this.ipAddressLimit || `Maximum limit reached: Only ${this.ipAddressLimit} IPs are allowed`,
        ],
        blueIcon: constants.color_code.blue_icon,
        isBtnDisabled: true,
        whitelistedIps: [],
        ipAddress: '',
        submissionLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        drawer: 'ui/drawer',
      }),
      invalidIp () {
        return !(
          this.ipAddress.length > 0 &&
          this.$refs.ipAddress &&
          this.$refs.ipAddress.valid
        )
      },
    },
    watch: {
      isValid: function(value){
        this.isBtnDisabled = !value ? true : false
      }
    },
    mounted () {
      this.mode = this.drawer.right.response.mode ? this.drawer.right.response.mode : 'create';
      this.permissionOptions = this.drawer.right.response.permissionOptions;
      this.loading = true;
      this.getPermissionOpts();
    },
    methods: {
      closeDrawer () {
        this.$store.commit('ui/drawer.right', {
          show: false,
          component: null,
          response: { updateDataList: true },
        })
      },
      isAllSelected(){
        var retValue = true;
        Object.keys(this.apiKeyItems).forEach((key) => { 
          if(this.apiKeyItems[key].hasPermission === false){
            retValue = false;
          }
        });
        return retValue;
      },
      selectAllPermissions(value){
        Object.keys(this.apiKeyItems).forEach((key) => { 
          this.apiKeyItems[key].hasPermission = value
        });
      },
      saveKeyInfo(){
        if (!this.$refs.keyName.validate()) return
        var permissions = {};
        Object.keys(this.apiKeyItems).forEach((key) => { 
          var permissionValue = this.apiKeyItems[key].hasPermission ? 'yes' : 'no';
          if(key !== 'select_all'){
            if(permissionValue === 'yes'){
              permissions[key] = permissionValue;
            }
          }
        });
        if (Object.keys(permissions).length === 0) {
          this.$store.commit('ui/snackbar', {
            message: 'You must assign at least one permission to continue.',
            type: 'error',
          })
          return
        }
        const payload = {
          name: this.apiKeyName,
          permissions,
          whitelisted_ips: this.whitelistedIps
        };
        this.submissionLoading = true
        if(this.mode === 'create'){
          $settings.createNewKey(payload).then(response => {
            this.$store.commit('ui/drawer.right', {
              show: false,
              component: null,
              response: { apiKey: response.data.api_key },
            })
          }).finally(() => {
            this.submissionLoading = false
          })
        } else if(this.mode === 'update'){
          $settings.updateApiKey(this.drawer.right.response.item.id, payload).then(response => {
            this.$store.commit('ui/snackbar', {
              message: 'Key updated successfully.',
              type: 'success',
              timeout: 2000,
            })
            this.closeDrawer();
          }).finally(() => {
            this.submissionLoading = false
          })
        }
      },
      manageSelection(){
        this.isSelectAll = this.isAllSelected();
      },
      getPermissionOpts(){
        this.permissionOptions.forEach((option) => {
          let title = this.permissionInfo[option] ? this.permissionInfo[option] : this.$options.filters.firstCharCapital(option.replace("_", " "));
          this.apiKeyItems[option] = {title, hasPermission: true}
        });
        if(this.mode === 'update'){
          this.isSelectAll = false;
          const { name, roles, whitelisted_ips } = this.drawer.right.response.item
          this.apiKeyName = name;
          this.whitelistedIps = [ ...whitelisted_ips ]
          Object.keys(this.apiKeyItems).forEach((key) => { 
            this.apiKeyItems[key].hasPermission = (key === 'select_all') ? 'false' : roles.includes(key)
          });
          if(this.isAllSelected()){ this.isSelectAll = true; }
        }
        this.loading = false;
      },
      onAddIpAddress () {
        this.whitelistedIps.push(this.ipAddress)
        this.ipAddress = ''
      },
      onRemoveIpAddress (index) {
        this.whitelistedIps.splice(index, 1)
      },
    },
  }
  </script>

<style lang="scss" scoped>
.v-list-item--link:before {
  background-color: transparent;
}
.v-list-item--active:hover::before {
  background-color: currentColor !important;
}
.ip-section {
  border: 1px solid #c2c2c2;
  padding: 15px;
}
.ip-list {
  max-height: 150px;
  overflow-y: auto;
}
.ip-address-title {
  background: white;
  padding: 0px 4px 0px 2px;
}
::v-deep .more-detail .v-text-field__details {
  margin-top: 8px !important;
}
</style>
